import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';

const EMPTY_MAP = Immutable.Map({});

export default class ParentBoundComponent extends React.PureComponent {
	constructor() {
		super();
		this.state = {
			data: EMPTY_MAP
		}
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (nextProps.data !== prevState.data) {
			return {
				data: nextProps.data
			};
		}
		return null;
	}

	getData() {
		return this.state.data || EMPTY_MAP;
	}

	setData(value) {
		this.state.data = value;
		if (this.props.onDataChange) {
			this.props.onDataChange(value);
		}
	}

	getProperty(name) {
		return this.getData().get(name);
	}

	setProperty(name, value) {
		this.setData(this.getData().set(name, value));
	}

}
